<template>
<v-dialog v-model="show_dialog" width="500">
  <v-card>
    <v-card-title class="secondary white--text">
      Send Notification
      <v-spacer></v-spacer>
      <v-btn icon dark @click="show_dialog=false">
        <v-icon>fa-times</v-icon>
      </v-btn>
      <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary"></v-progress-linear>
    </v-card-title>
    <v-container>
      <v-row align="center">
        <v-col cols="12" v-if="account">
          <v-text-field outlined hide-details label="Account" :value="account.name" readonly></v-text-field>
        </v-col>
        <v-col cols="12" v-if="project">
          <v-text-field outlined hide-details label="Regarding project" :value="project.title" readonly></v-text-field>
        </v-col>
        <v-col cols="12" v-if="contest">
          <v-text-field outlined hide-details label="For Contest" :value="contest.title" readonly></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-autocomplete label="Website Notification" hide-details clearable :items="templates" item-text="name" item-value="id" v-model="selected_template"></v-autocomplete>
        </v-col>
        <v-col cols="12">
          <v-autocomplete label="Email Notification" hide-details clearable :items="email_templates" item-text="name" item-value="id" v-model="selected_email_template"></v-autocomplete>
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions class="grey lighten-3">
      <v-spacer></v-spacer>
      <v-btn color="primary" dark  @click="sendNotification" :loading="loading">Send</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>
<script>
export default {
  name: "",
  data: () => ({
    show_dialog: false,
    account: null,
    project: null,
    contest: null,
    templates: [],
    email_templates: [],
    loading: false,
    selected_template: null,
    selected_email_template: null,
  }),
  created() {
    this.$eventBus.$on('send_notification', this.openNotifications)
  },
  methods: {
    async load() {
      this.loading = true
      this.templates = await this.$api(`/account/admin/notification-templates`)
      this.email_templates = await this.$api(`/account/admin/email-notification-templates`)
      this.loading = false
    },
    async sendNotification() {
      if (!this.selected_template && !this.selected_email_template){
        return alert("No template selected")
      }
      this.loading = true;
      try {
        await this.$api({
          method: "POST",
          url: `/account/admin/notifications/send`,
          data: {
            account_id: this.account.id,
            project_id: this.project ? this.project.id : null,
            contest_id: this.contest ? this.contest.id : null,
            notification_template_id: this.selected_template,
            email_template_id: this.selected_email_template
          }
        })
        this.show_dialog = false
      } catch (ex) {
        alert(ex.error)
      }

      this.loading = false
    },
    async openNotifications(options) {
      console.log("called", 'openNotifications')
      this.show_dialog = true
      this.account = options.account
      this.project = options.project
      this.contest = options.contest
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
